import React, { memo } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { QUEST_STATUSES } from '../clan_quests_constants'
import styles from './ArcProgressbarQuest.scss'

const ArcProgressbarQuest = memo(({
    isAvailable,
    currentProgress,
    requiredProgress,
    status,
    level,
}) => {
    const progress = 75 * (currentProgress / requiredProgress)
    const sparkLocation = 45 + (currentProgress / requiredProgress * 270)
    const isInProgress = status === QUEST_STATUSES.INCOMPLETE && isAvailable

    return (
        <React.Fragment>
            <div className={classNames(styles.arc, styles[`arc__level-${level}`])}>
                <div
                    style={{ '--progress': `${progress}%` }}
                    className={classNames(
                        styles.progressbar,
                        isInProgress && styles['progressbar__in-progress'],
                        status !== QUEST_STATUSES.INCOMPLETE && styles['progressbar__completed'],
                    )}
                />
                {isAvailable && (
                    <div
                        style={{ transform: `rotate(${sparkLocation}deg)` }}
                        className={styles['spark-wrapper']}
                    >
                        <div className={styles.spark} />
                    </div>
                )}
            </div>
        </React.Fragment>
    )
})

ArcProgressbarQuest.propTypes = {
    isAvailable: PropTypes.bool.isRequired,
    level: PropTypes.oneOf([1,2,3]).isRequired,
    currentProgress: PropTypes.number.isRequired,
    requiredProgress: PropTypes.number.isRequired,
    status: PropTypes.oneOf(Object.values(QUEST_STATUSES)).isRequired,
}

export default ArcProgressbarQuest



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ArcProgressbar/ArcProgressbarQuest.jsx